import React from 'react'
import Slider from '../inc/Slider'
import Products from './Products'
import AddHomevisit from '../AddHomevisit'

import petcare from "../images/pet care photo.jpg";
import petgroomingcare from "../images/PET_Gromming.jpg";
import vetconsultancy from "../images/VET CONSULTANCY.jpg";



import "./Home.css";
import Header from '../inc/Header'

function Home() {
  return (
    <div>
      <Header/>
      <br />
      <br />
      <br />
      <br />

      <Slider />
      <br />
       <div className="album py-0">
          <div className="container">
            <center>
      <h2 className='mb-0'>Pet Plazaa – Leading the Way in Pet Products & Services in <b style={{color:"#CC000A"}}>Krishnagar</b></h2>
      <p><small>Trusted by Pet Owners: With numerous positive reviews, we have earned the trust of Krishnagar’s pet-loving community</small></p>
      </center>
      </div>
      </div>
      <Products />
   <div className="album py-0">
          <div className="container">
            <center>
<h1 className='mb-0'>Quick & Easy <b style={{color:"#CC000A"}}>Prescription</b> Upload</h1>
<p><small>Prepare Your Prescription: Ensure that your pet's prescription is legible and includes all necessary details, such as the pet's name, medication name, dosage, and prescribing veterinarian's information.</small></p>
</center>
</div>
</div>
      <div className='prescription'>
        <div className="album py-0">
          <div className="container">
            <div className="row">

              <div className="col-md-6 mt-2">
                <AddHomevisit />
              </div>
              <div className="col-md-6 mt-2">
                <br />
                <img src={petcare} className="card-img-top" alt="petcare" />

              </div>
            </div>
          </div>
        </div>
      </div>
      <br/>
         <div className="album py-0">
          <div className="container">
            <center>
<h1 className='mb-0'>Your Trusted <b style={{color:"#CC000A"}}>Vet Consultancy & Grooming Services</b> for Pets</h1>
<p><small>Our Vet Consultancy Service and Pet Grooming Service are designed to provide expert care tailored to the unique needs of your furry friends.</small></p>
</center>
</div>
</div>
<h1></h1>

      <div className='petservice'>
        <br />
        <br />
        <div className="album py-0">
          <div className="container">
            <div className="row">


              <div className="col-md-6 mt-2">
                <a href='vet-consultancy'>
                  <img src={vetconsultancy} className="d-block w-100" alt="vetconsultancy" />
                  <center>

                    <button style={{ margin: "2px" }} className='learn mb-2 mt-2'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></button>
                  </center>
                </a>
              </div>

              <div className="col-md-6 mt-2">
                <a href='GroomingBook'>
                  <img src={petgroomingcare} className="d-block w-100" alt="petgroomingcare" />

                  <center>

                    <button style={{ margin: "2px" }} className='learn mb-2 mt-2'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></button>
                  </center>
                </a>

              </div>
            </div>
          </div>
        </div>
        <br />
      </div>

      <div className='back'>
        <div className="album py-0">
          <div className="container ">
            <div className="row ">
              <div className="col-md-3 mt-4">
                <h6 className='mb-1' style={{color:"white"}}>24hr Delivery</h6>
                <p style={{color:"white"}}>In 5 cities</p>
              </div>
               <div className="col-md-3 mt-4">
                <h6 className='mb-1' style={{color:"white"}}>1,50,000+ </h6>
                <p style={{color:"white"}}>Happy pet parent</p>
              </div>
               <div className="col-md-3 mt-4">
                <h6 className='mb-1' style={{color:"white"}}>Complimentary vet consult</h6>
                <p style={{color:"white"}}>For every new member</p>
              </div>
               <div className="col-md-3 mt-4">
                <h6 className='mb-1' style={{color:"white"}}>Pet Pharmacy</h6>
                <p style={{color:"white"}}>Exclusive</p>
              </div>

            </div>

          </div>
        </div>

      </div>

    </div>
  )
}

export default Home